import {
  PageFundraisers,
  PageShowFundraiser,
  FundraiserProject,
  FundraisersFilter,
  FundraiserUpdates,
  FundingDetails,
  DonatorsComments,
  FundraiserReportQuestion,
  LoginButton,
  FundraiserCreatePage,
  Checkout,
  EditProfile
} from './fundraisers/'

import { PageCheckout } from './checkout'
import { PageHeader } from './layouts'
import { PageHome } from './PageHome'

export default [
  PageCheckout,
  PageFundraisers,
  PageShowFundraiser,
  FundraiserProject,
  FundraisersFilter,
  FundraiserUpdates,
  FundingDetails,
  DonatorsComments,
  LoginButton,
  FundraiserCreatePage,
  PageHeader,
  PageHome
]



// WEBPACK FOOTER //
// ./resources/js/views/components.js